"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./lib/gate/EventDispatcher");
var mobx_1 = require("mobx");
var helper_1 = require("lib/functions/helper");
var axiosModule = require("axios");
var Model = (function () {
    function Model(gate, dataStore) {
        this.gate = gate;
        this.dataStore = dataStore;
        this.axios = axiosModule.create();
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                results = [];
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false)) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    Model.prototype.getApiKeyBySlug = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/api/key/credentials", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            if (Object.keys(r.data).length > 0) {
                                this.json_data.api_key_user_id = r.data.userId;
                                this.json_data.api_key_profile_id = r.data.profileId;
                                this.json_data.profile = r.data.profile;
                                this.json_data.type = r.data.type;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_1 = _a.sent();
                        console.log("some error with getApiKeyBySlug", error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getPrograms = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var campusId, options, r, programs, defaultProgramIds_1, newPrograms, value_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        campusId = helper_1.getPartsByDelimiter(value)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/programs/" + campusId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            programs = helper_1.DEFAULT_DEW_INFO.campus.programs;
                            defaultProgramIds_1 = programs.map(function (_a) {
                                var id = _a.id;
                                return id;
                            });
                            newPrograms = r.data
                                .filter(function (_a) {
                                var id = _a.id;
                                return defaultProgramIds_1.includes(id);
                            })
                                .map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, description = _a.description, versionId = _a.versionId;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + description + helper_1.DELIMITER + versionId
                                });
                            });
                            this.json_data.programs = newPrograms;
                            value_1 = newPrograms[0].value;
                            this.json_data.program = value_1;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_2 = _a.sent();
                        console.log("some error with getPrograms", error_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getDefaultCampus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, id, name, code, campus;
            return __generator(this, function (_b) {
                _a = helper_1.DEFAULT_DEW_INFO.campus, id = _a.id, name = _a.name, code = _a.code;
                campus = "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code;
                this.json_data.campus = campus;
                this.dispatcher.dispatch();
                return [2];
            });
        });
    };
    Model.prototype.getUpcomingTerms = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, startingTerms, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/admissions/upcoming-terms", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            startingTerms = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, start_date = _a.start_date, end_date = _a.end_date;
                                return ({
                                    name: name + "(" + helper_1.formatStandarUSDate(start_date) + ")",
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + start_date + helper_1.DELIMITER + end_date
                                });
                            });
                            this.json_data.startingTermList = startingTerms;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_3 = _a.sent();
                        console.log("some error with getUpcomingTerms", error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getStartingTermsByMajor = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var majorId, options, r, startingTerms, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        majorId = helper_1.getPartsByDelimiter(value)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/terms/by-major/" + majorId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            startingTerms = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, start_date = _a.start_date, end_date = _a.end_date;
                                return ({
                                    name: name + "(" + helper_1.formatStandarUSDate(start_date) + ")",
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + start_date + helper_1.DELIMITER + end_date
                                });
                            });
                            this.json_data.startingTermList = startingTerms;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_4 = _a.sent();
                        console.log("some error with getStartingTermsByMajor", error_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getMajorVersionByProgram = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, versionId, options, r, newSpecializations, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = helper_1.getPartsByDelimiter(value), versionId = _a[4];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/major-version/specializations/" + versionId, {
                                data: options
                            })];
                    case 1:
                        r = _b.sent();
                        if (r.success) {
                            newSpecializations = r.data.specializations.map(function (_a) {
                                var id = _a.id, name = _a.name;
                                return ({
                                    name: "" + name,
                                    value: "" + id + helper_1.DELIMITER + name
                                });
                            });
                            this.json_data.specializationList = newSpecializations;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_5 = _b.sent();
                        console.log("some error with getPrograms", error_5);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.fileUpload = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, request, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append("autobiography", file);
                        request = {
                            method: "post",
                            url: process.env.BASE_DOMAIN + "/uploadV3",
                            responseType: "json",
                            data: formData,
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        };
                        return [4, this.axios(request)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2, data];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], Model.prototype, "user", void 0);
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,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